import { render, staticRenderFns } from "./TkTextBox.vue?vue&type=template&id=fd28cb72&scoped=true&functional=true&"
import script from "./TkTextBox.vue?vue&type=script&lang=js&"
export * from "./TkTextBox.vue?vue&type=script&lang=js&"
import style0 from "./TkTextBox.vue?vue&type=style&index=0&id=fd28cb72&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  "fd28cb72",
  null
  
)

export default component.exports